import React, { PropTypes } from "react";
import _, { values } from "lodash";
import { connect } from "react-redux";
import { COMMON_FAIL_MESSAGE, BASE_IMAGES_URL, converDateIntoLocalwithmonth } from "Constants";
import Button from "react-bootstrap-button-loader";
import ViewBillingHistorydetails from "./viewbillingdetails";
import PaymentinvoiceModal from "./paymentmodal";
import { updatetoInvoice, fetchclientbillinghistory, downloadInvoicePdf } from "AccountSettingsAction";
import LocaleStrings from "Languages";

class BillinghistoryListitem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resetpassword: false,
            loading: false,
            allowingaccess: false,
            selectedUsers: [],
            showEmailPreviewModal: false,
            payModal: false,
            isOpen: false,
            btnconvertoInvoice: false,
        };
    }

    openModal = () => {
        this.setState({
            isOpen: true,
        });
    };
    closeModal = () => {
        this.setState({ isOpen: false });
    };
    openpayModal = () => {
        this.setState({
            payModal: true,
        });
    };
    closepayModal = () => {
        this.setState({ payModal: false });
    };

    downloadPdf = (values) => {
        if (values.type == 'quote' && values.quotepdf !== '' && values.quotepdf !== null) {
            var filename = 'quote.pdf';
            var uri = `${BASE_IMAGES_URL}/${values.quotepdf}?api_key=${this.props.session.apiKey}&download=true`;

            var link = document.createElement("a");
            link.href = uri;

            //set the visibility hidden so it will not effect on your web-layout
            link.style = "visibility:hidden";
            link.download = filename;
            link.target = "_blank";

            //this part will append the anchor tag and remove it after automatic click
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } else if (values.type == 'invoice' && values.invoicepdf !== '' && values.invoicepdf !== null) {
            var filename = 'invoice.pdf';
            var uri = `${BASE_IMAGES_URL}/${values.invoicepdf}?api_key=${this.props.session.apiKey}&download=true`;

            var link = document.createElement("a");
            link.href = uri;

            //set the visibility hidden so it will not effect on your web-layout
            link.style = "visibility:hidden";
            link.download = filename;
            link.target = "_blank";

            //this part will append the anchor tag and remove it after automatic click
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
        }
    };


    render() {
        let { values, index } = this.props;
        // console.log('values',values)
        let tabledate = "";
        tabledate = converDateIntoLocalwithmonth(values.createdon).format("D MMM YYYY");
        let bg = {
            backgroundColor: '#fff'
        }
        if (values.type == 'quote') {
            bg = {
                backgroundColor: '#DCDCDC'
            }
        }
        let statusbg = {
            backgroundColor: 'burlywood',
            width: '60px',
        }
        if (values.status == 'paid') {
            statusbg = {
                backgroundColor: '#00c04b',
                color: '#fff',
                width: '50px',
                textAlign: 'center'
            }
        }
        return (
            <tr
                key={index} id={index}
                style={bg}
            >
                <td>
                    <div
                        className="row"
                        style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}
                    >
                        {values.type == 'quote' ? (
                            <div className="vcenter">Quote #{values.id}</div>
                        ) : (
                            <div className="vcenter">Invoice #{values.id}</div>
                        )}

                    </div>
                </td>
                <td>
                    <div
                        className="row"
                        style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
                    >
                        <div className="vcenter">
                            {tabledate}
                        </div>
                    </div>
                </td>
                <td>
                    {values.type == 'quote' ? ('-') : (
                        <div className="status-tag" style={statusbg}>

                            {values.userlimit}
                        </div>
                    )}

                </td>
                <td>
                    <div
                        className="row"
                        style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
                    >
                        {values.type == 'quote' ? ('-') : (
                            <div className="vcenter ">
                                {_.startCase(values.status)}
                            </div>
                        )}

                    </div>
                </td>
                <td>
                    <div className="d-flex">

                        {values.status == 'unpaid' && values.type == 'quote' ? (
                            <Button
                                className="btn-custom-blue schedule-add-button"
                                onClick={() => this.openpayModal()}
                                style={{ marginLeft: '15px' }}
                            >
                                {LocaleStrings.accountsetting_billingdetails_table_buttonpay}
                            </Button>
                        ) : (
                            ''
                        )}
                        <Button
                            className="btn-custom-blue schedule-add-button"
                            style={{ marginLeft: '15px' }}
                            onClick={() => this.openModal()}
                        >
                            {LocaleStrings.accountsetting_billingdetails_table_buttonview}

                        </Button>
                        <Button
                            className="btn-custom-blue schedule-add-button"
                            style={{ marginLeft: '15px' }}
                            onClick={() => this.downloadPdf(values)}
                            loading={this.state.loading}
                        >
                            {LocaleStrings.accountsetting_billingdetails_table_buttondownload}
                        </Button>

                        {this.state.isOpen ? (
                            <ViewBillingHistorydetails
                                isOpen={this.state.isOpen}
                                onClose={this.closeModal}
                                data={values}
                            />
                        ) : (
                            ""
                        )}
                        {this.state.payModal ? (
                            <PaymentinvoiceModal
                                isOpen={this.state.payModal}
                                onClose={this.closepayModal}
                                data={values}
                            />
                        ) : (
                            ""
                        )}
                        {values.status == 'cancelled' ? (
                            <div className="text-danger mt-2" style={{ marginLeft: '15px' }}>Quote Cancelled</div>
                        ) : ('')}
                    </div>

                </td>
            </tr>
        );
    }
}

export var mapStateToProps = (state) => {
    return {
        session: state.session,
    };
};
export default connect(mapStateToProps, { updatetoInvoice, fetchclientbillinghistory, downloadInvoicePdf })(BillinghistoryListitem);
